





























import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({})
export default class EditModalLayout extends Vue {
  @Prop()
  isOpenModal!: boolean

  @Prop()
  isNew!: boolean

  get submitLabel(): any {
    return this.isNew ? this.$t('button.register') : this.$t('button.save')
  }
}
